import { ReactNode } from "react";

export const Price = ({ children }: { children: ReactNode }) => (
  <span className="whitespace-nowrap text-2xl leading-8 text-neutral-900">{children} &#8381;</span>
);
